export default {
    yourTree: 'JSON tree',
    addRootItem: 'Create root item',
    addItemtoRoot: 'Add item to root item',
    pasteInRootItem: 'Paste in root item',
    insertCode: 'Insert JSON',
    searchPropOrValue: 'Search your property name or value',
    selectAllItems: 'Select all items',
    unSelectAllItems: 'Unselect all items',
    openAllItems: 'Open all children',
    closeAllItems: 'Close all children',
    itemMenu: {
        title: 'Settings',
        open: 'Open all item',
        close: 'Close all item',
        add: 'Add item',
        edit: 'Edit item',
        copy: 'Copy',
        paste: 'Paste',
        remove: 'Delete'
    },
    editItem: {
        title: 'Edit item',
        propName: 'Property name',
        propType: 'Property type',
        selectOptions: 'Choose options',
        propOutputType: 'Output property type',
        propValue: 'Property value',
    },
    outputFormatted: 'Formatted output'
}
